import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { ReportGenerateService } from './report-generate.service';
import { ReportPrintExportOptionsComponent } from './report-print-export-options/report-print-export-options.component';
import { PrintService } from '../../services/print/print.service';
import { OptionDropdownModule } from '@certemy/ui-components';

@NgModule({
  imports: [CommonModule, CertemyCommonModule, OptionDropdownModule],
  exports: [ReportPrintExportOptionsComponent],
  providers: [ReportGenerateService, PrintService],
  declarations: [ReportPrintExportOptionsComponent],
})
export class ReportGenerateModule {}
